(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-purchase-bar"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-purchase-rating-link]');

    if (!link) {
      return;
    }

    const anchorId = link.hash.slice(1);
    const navigationLink = document.querySelector(`[data-product-anchor-nav] [data-anchor-id="${CSS.escape(anchorId)}"]`);

    if (navigationLink) {
      event.preventDefault();
      navigationLink.click();
      return;
    }

    const target = document.getElementById(anchorId);

    if (!target) {
      return;
    }

    event.preventDefault();
    history.replaceState(null, '', link.hash);
    target.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'start'
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-video-modal-button"] && !Shopify.designMode) return;
  try {
    window.openProductVideoModal = (button) => {
    const modalId = button.getAttribute('aria-controls');
    const modal = modalId ? document.getElementById(modalId) : null;

    if (!modal) return;

    const device = window.matchMedia('(max-width: 699px)').matches ? 'mobile' : 'desktop';
    const template = modal.querySelector(`[data-product-video-template="${device}"]`);
    const videoContainer = modal.querySelector('[data-product-video-container]');

    if (!template || !videoContainer) return;

    const content = template.content.cloneNode(true);
    content.querySelectorAll('script').forEach((script) => script.remove());
    videoContainer.replaceChildren(content);

    modal._productVideoButton = button;
    document.body.append(modal);
    modal.hidden = false;
    button.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('product-video-modal-open');
    requestAnimationFrame(() => modal.querySelector('[data-product-video-close]')?.focus({ preventScroll: true }));
  };

  window.closeProductVideoModal = (modal) => {
    if (!modal || modal.hidden) return;

    modal.hidden = true;
    modal._productVideoButton?.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('product-video-modal-open');
    modal.querySelector('[data-product-video-container]')?.replaceChildren();
    modal._productVideoButton?.focus({ preventScroll: true });
  };

  if (!window.productVideoModalDelegationV2Ready) {
    window.productVideoModalDelegationV2Ready = true;

    window.addEventListener('click', (event) => {
      const button = event.target.closest?.('[data-product-video-button]');

      if (button) {
        event.preventDefault();
        event.stopImmediatePropagation();
        window.openProductVideoModal(button);
        return;
      }

      const closeButton = event.target.closest?.('[data-product-video-close]');

      if (closeButton) {
        event.preventDefault();
        window.closeProductVideoModal(closeButton.closest('[data-product-video-modal]'));
      }
    }, true);

    window.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;

      document.querySelectorAll('[data-product-video-modal]:not([hidden])').forEach((modal) => {
        window.closeProductVideoModal(modal);
      });
    });
  }

  if (!customElements.get('product-video-modal-trigger')) {
    customElements.define(
      'product-video-modal-trigger',
      class ProductVideoModalTrigger extends HTMLElement {
        connectedCallback() {
          this.abortController = new AbortController();
          this.mobileQuery = window.matchMedia('(max-width: 699px)');
          this.button = this.querySelector('[data-product-video-button]');
          this.modal = this.querySelector('[data-product-video-modal]');
          this.videoContainer = this.modal?.querySelector('[data-product-video-container]');
          this.closeButton = this.modal?.querySelector('[data-product-video-close]');

          requestAnimationFrame(() => this.mountButton());

          this.modal?.addEventListener('click', (event) => {
            if (event.target === this.modal) this.closeModal();
          }, {
            signal: this.abortController.signal,
          });
        }

        disconnectedCallback() {
          this.abortController?.abort();
          this.closeModal();
          this.clearVideo();
          this.trigger?.classList.remove('product-video-modal-trigger-slot');

          if (this.modal?.parentElement === document.body) this.modal.remove();
        }

        mountButton() {
          const triggerId = this.dataset.triggerId?.replace(/^#/, '').trim();
          const root = this.closest('product-rerender') || this.closest('.shopify-section');

          if (!triggerId || !root || !this.button || !this.modal) return;

          this.trigger = root.querySelector(`#${CSS.escape(triggerId)}`);

          if (!this.trigger) return;

          this.trigger.replaceChildren(this.button);
          this.trigger.classList.add('product-video-modal-trigger-slot');
          this.button.hidden = false;
        }

        closeModal() {
          window.closeProductVideoModal(this.modal);
        }

        clearVideo() {
          this.videoContainer?.replaceChildren();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
